/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
/**
 * Creates a data stub from a more complex data structure
 * @param data
 * @param fields
 * @returns
 */
export function createStub(data, fields) {
    var stub = {};
    for (let field of fields) {
        if (field.indexOf("$") !== 0) {
            stub[field] = data[field];
        }
    }
    return stub;
}
export async function moveDocument(docId, sourceCollection, targetCollection) {
    var data = await sourceCollection.fetchData(docId);
    await sourceCollection.deleteDoc(docId);
    return targetCollection.add(data, { id: docId });
}
//# sourceMappingURL=firestore-util.js.map